import axios from "axios";

export const ndeFormInstance = axios.create({
    baseURL: "https://5370h1xoa0.execute-api.ap-south-1.amazonaws.com/default",
});

// Add a request interceptor
ndeFormInstance.interceptors.request.use(
  function (config) {
    config.data.utm_source = sessionStorage.getItem('utm_source') ? JSON.parse(sessionStorage.getItem('utm_source')) : {};

     if (sessionStorage.getItem('blog_banner')) {
        config.data.utm_source.banner = JSON.parse(sessionStorage.getItem('blog_banner'))
     }

    //  Track form ID under analytics 
    if (config.data.form_id) {
        config.data.utm_source.form_id = config.data.form_id;
        delete config.data.form_id;
     }

    //  Get Page URL 
    config.data.utm_source.currentPage = window.location.href;
    
     config.data.utm_source = JSON.stringify(config.data.utm_source);
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
ndeFormInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
